/**
 *
 *
 *
 */
class EncodingError extends Error {
    /**
 *
 *
 *
 *
 */
    constructor(msg) {
        super(msg);
        this.name = 'EncodingError';
    }
}
export { EncodingError };
